

import { Modal, ModalBody, ModalFooter } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import {
    clearRedux,
    exceptionSearchDetailsRequest,
    exceptionGetDetailsRequest,
} from 'Redux/actions';

import CustomCard from 'Components/Card';
import { Tooltip, Select, Button } from "@gpstrackit/react-controls";

import {
    Icon,
    IconButton,
    OutlinedInput,
    InputAdornment,
    FormControl,
} from '@mui/material';

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

const ExceptionDetails = (props) => {

    const { messages } = useIntl()
    const dispatch = useDispatch()

    const [sourceEntityName, setSourceEntityName] = useState({
        id: "all",
        name: messages['exception_detail_all']
    })

    const [detail, setDetail] = useState(null)
    const [message, setMessage] = useState(null);


    useEffect(() => {
        if (message || message === "") {
            const timer = setTimeout(() => {
                dispatch(exceptionSearchDetailsRequest({
                    targetAccountId: account?.targetAccountId || account?.newEntityId,
                    sourceEntityName: sourceEntityName?.id === 'all' ? null : sourceEntityName?.id,
                    message
                }))
            }, 500)
            return () => clearTimeout(timer);
        }
    }, [message]);

    //Redux Store
    const {
        loading,
        openModal,
        account,
        exceptions,
        details,
    } = useSelector(state => state.exceptionDetailsRedux)

    //Close window
    const closeModal = () => {
        setDetail(null);
        setSourceEntityName({
            id: "all",
            name: messages['exception_detail_all']
        })
        setMessage(null);
        dispatch(clearRedux("EXCEPTION_DETAILS"));
    }

    useEffect(() => {
        if (openModal && account) {
            dispatch(exceptionSearchDetailsRequest({
                targetAccountId: account?.targetAccountId || account?.newEntityId,
                sourceEntityName: sourceEntityName?.id === 'all' ? null : sourceEntityName?.id
            }))
        }
    }, [openModal])

    useEffect(() => {
        if (details) {
            let newResult
            try {
                newResult = JSON.parse(JSON.parse(details?.record))
            } catch (exc) {
                try {
                    newResult = {
                        ...details,
                        record: details?.record?.replace(/["\\]/g, "").trim()
                    }
                } catch (exc) { }
            }
            setDetail(newResult)
            dispatch(clearRedux("EXCEPTION_DETAILS", { details: null }));
        }
    }, [details])

    return (
        <Modal
            open={openModal}
            title={messages['exception_detail_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                {
                    !detail ? (
                        <div style={{ padding: '0 10px', marginBottom: 30 }}>
                            <Select
                                id="entity-name"
                                name="entity"
                                label={messages['exception_detail_entity']}
                                placeholder={messages['exception_detail_entity']}
                                value={sourceEntityName}
                                options={[
                                    {
                                        id: "all",
                                        name: messages['exception_detail_all']
                                    },
                                    {
                                        id: "behavior",
                                        name: messages['exception_detail_behavior']
                                    },
                                    {
                                        id: "categories",
                                        name: messages['exception_detail_categories']
                                    },
                                    {
                                        id: "contacts",
                                        name: messages['exception_detail_contacts']
                                    },
                                    {
                                        id: "devices",
                                        name: messages['exception_detail_devices']
                                    },
                                    {
                                        id: "drivers",
                                        name: messages['exception_detail_drivers']
                                    },
                                    {
                                        id: "users",
                                        name: messages['exception_detail_users']
                                    },

                                    {
                                        id: "geofences",
                                        name: messages['exception_detail_geofences']
                                    },
                                    {
                                        id: "maintenance",
                                        name: messages['exception_detail_Maintenance']
                                    },

                                ]}
                                textField="name"
                                valueField="id"
                                onChange={(item) => {
                                    setSourceEntityName(item)
                                    dispatch(exceptionSearchDetailsRequest({ targetAccountId: account?.targetAccountId || account?.newEntityId, sourceEntityName: item?.id === 'all' ? null : item?.id }))
                                }}
                            />
                            <FormControl style={{ width: '100%', marginTop: 10, marginBottom: 10 }}>
                                <OutlinedInput
                                    id="custom-search"
                                    placeholder={messages['exception_detail_search_by_message']}
                                    type="text"
                                    style={{ height: 38 }}
                                    value={message || ''}
                                    fullWidth={true}
                                    onChange={() => setMessage(event.target.value || '')}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <Icon style={{ marginRight: 5, opacity: 0.4 }}>search</Icon>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            {
                                exceptions.length > 0 ? exceptions.map((item, index) => {
                                    return (
                                        <CustomCard
                                            key={index}
                                            hideButton={true}
                                            width={12}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div style={{ display: 'grid' }}>
                                                    <div>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>Id</label><span>{item?.sourceEntityId}</span>
                                                    </div>
                                                    <div>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['exception_detail_entity']}</label><span>{item?.sourceEntityName}</span>
                                                    </div>
                                                    <div>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['exception_detail_created_on']}</label><span>{item?.createdOn && getDateFormatted(item?.createdOn, "date", "datetime")}</span>
                                                    </div>
                                                    <div>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['exception_detail_message']}</label><span>{item?.message}</span>
                                                    </div>
                                                </div>
                                                <div style={{ width: 40, height: 40 }}>
                                                    <Tooltip
                                                        title={messages['exception_detail_exception_detail']}
                                                    >
                                                        <IconButton
                                                            onClick={() => dispatch(exceptionGetDetailsRequest(item?.id))}
                                                            size="large">
                                                            <Icon>info</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </CustomCard>
                                    );
                                }) : <div style={{
                                    marginTop: 10,
                                    justifyContent: 'center',
                                    display: 'flex'
                                }}><span style={{ opacity: 0.8 }}>{messages['exception_detail_no_data_available']}</span></div>
                            }
                        </div>
                    ) : (
                        <div style={{ padding: '0 10px', marginBottom: 30 }}>
                            <pre>
                                {JSON.stringify(detail, null, 2)}
                            </pre>
                        </div>
                    )
                }
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={() => {
                        if (detail) setDetail(null)
                        else closeModal()
                    }}
                    className="btn-dark-blue"
                >
                    {detail ? messages['common_back'] : messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
export default ExceptionDetails